/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_StartInputs */

const en_mk_tb_start = /** @type {(inputs: Mk_Tb_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open your team workspace`)
};

const id_mk_tb_start = /** @type {(inputs: Mk_Tb_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka workspace tim`)
};

/**
* | output |
* | --- |
* | "Open your team workspace" |
*
* @param {Mk_Tb_StartInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_start = /** @type {((inputs?: Mk_Tb_StartInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_StartInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_start(inputs)
	return en_mk_tb_start(inputs)
});